import type { ArtifactVersionRead } from '@/artifacts/schemas'
import { ViewerDocumentKind, ViewerDownloadTargetKind, ViewerOpenContextKind, type ContentViewerSession } from '@/content-viewer/store/schemas'
import { createViewerSession } from '@/content-viewer/utils/create-viewer-session'

type BuildArtifactViewerSessionArgs =
  | {
      artifactVersion: ArtifactVersionRead
      conversationId?: string
      autoOpen: true
    }
  | {
      artifactVersion: ArtifactVersionRead
      conversationId: string
      autoOpen?: false
    }

export function buildArtifactViewerSession(args: BuildArtifactViewerSessionArgs): ContentViewerSession {
  const { artifactVersion } = args

  return createViewerSession({
    document: {
      kind: ViewerDocumentKind.ARTIFACT,
      artifactVersionId: artifactVersion.id,
      name: artifactVersion.name,
      downloadTarget: {
        kind: ViewerDownloadTargetKind.ARTIFACT_DOCX,
        artifactVersionId: artifactVersion.id,
      },
    },
    context: args.autoOpen
      ? {
          kind: ViewerOpenContextKind.AUTO_OPEN,
          artifactVersionId: artifactVersion.id,
          ...(args.conversationId ? { conversationId: args.conversationId } : {}),
        }
      : {
          kind: ViewerOpenContextKind.CHAT_ARTIFACT,
          artifactVersionId: artifactVersion.id,
          conversationId: args.conversationId,
        },
  })
}
